import { render, staticRenderFns } from "./TheData.vue?vue&type=template&id=5231bd23&scoped=true&"
import script from "./TheData.vue?vue&type=script&lang=js&"
export * from "./TheData.vue?vue&type=script&lang=js&"
import style0 from "./TheData.vue?vue&type=style&index=0&id=5231bd23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231bd23",
  null
  
)

export default component.exports